export const dayOne = {
    reverse: false,
    inverse: true,
    topLine: "Day 1",
    headline: "13 Sep 2023, Wednesday",
    schedule: [
        ["14:00 - 16:00", "Delegate Workshop"]
        // ["19:30 - 22:00", "Cocktail Reception Delegate Registration and Badge Distribution"]
    ],
};